import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';

import './Controls.css';
import { getNumberWithoutSpaces } from '../../../../../../common/utils/format';
const Controls = ({ prev, next }) => {
  return (
    <div className="controls">
      {prev ? (
        <div className="control">
          <Button block size="large" className="controlBtn">
            <Link to={`/executorship/request/${prev.id}`}>
              Предыдущая заявка
            </Link>
          </Button>
          <span className="sub">
            {getNumberWithoutSpaces(prev.info.requestNumber)}
          </span>
        </div>
      ) : null}
      {next ? (
        <div className="control">
          <Button block size="large" className="controlBtn">
            <Link to={`/executorship/request/${next.id}`}>
              Следующая заявка
            </Link>
          </Button>
          <span className="sub">
            {getNumberWithoutSpaces(next.info.requestNumber)}
          </span>
        </div>
      ) : null}
    </div>
  );
};
export default Controls;
